import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import TabPanel from '../TabPanel';
import styles from './index.module.css';

import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import BusinessIcon from '@mui/icons-material/Business';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LanguageIcon from '@mui/icons-material/Language';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import HubIcon from '@mui/icons-material/Hub';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import PlaylistAddCheckCircleOutlinedIcon from '@mui/icons-material/PlaylistAddCheckCircleOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import CloseIcon from '@mui/icons-material/Close';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';

import PromoShowcaseSettingsPanel from '../PromoShowcaseSettingsPanel';
import PromoStoreSettingsPanel from '../PromoStoreSettingsPanel';
import DecoratorMatrix from '../DecoratorMatrix';
import QuickBooksSettings from '../QuickBooksSettings';
import StripeSettings from '../StripeSettings';
import ShipStationSettings from '../ShipStationSettings';
import BinatedSettings from '../BinatedSettings';
import PromoWorldApiSettings from '../PromoWorldApiSettings';
import GooglePlacesSettings from '../GooglePlacesSettings';
import OneSourceSettings from '../OneSourceSettings';

import EmailTemplatesTab from '../../pages/instances/settings/global-settings/EmailTemplatesTab';
import TaxCodesTab from '../../pages/instances/settings/global-settings/TaxCodesTab';
import PaymentTermsTab from '../../pages/instances/settings/global-settings/PaymentTermsTab';
import ShippingAccountsTab from '../../pages/instances/settings/global-settings/ShippingAccountsTab';
import ThirdPartyShippingAccountsTab from '../../pages/instances/settings/global-settings/ThirdPartyShippingAccountsTab';
import ProjectNumbersTab from '../../pages/instances/settings/global-settings/ProjectNumbersTab';
import CustomizationMethodsTab from '../../pages/instances/settings/global-settings/CustomizationMethodsTab';
import NextActionTypesTab from '../../pages/instances/settings/global-settings/NextActionTypesTab';
import ClientStatusesTab from '../../pages/instances/settings/global-settings/ClientStatusesTab';
import SupplierStatusesTab from '../../pages/instances/settings/global-settings/SupplierStatusesTab';
import SubStatusesTab from '../../pages/instances/settings/global-settings/SubStatusesTab';
import DefaultsTab from '../../pages/instances/settings/global-settings/DefaultsTab';
import CurrencySettingsTab from '../../pages/instances/settings/global-settings/CurrencySettingsTab';
import CommissionsTab from '../../pages/instances/settings/global-settings/CommissionsTab';
import BillingPaymentMethodsTab from '../../pages/instances/settings/global-settings/BillingPaymentMethodsTab';
import BillingHistoryTab from '../../pages/instances/settings/global-settings/BillingHistoryTab';
import BillingRenewalTab from '../../pages/instances/settings/global-settings/BillingRenewalTab';
import MarketingConnectionsPanel from '../../pages/instances/settings/global-settings/MarketingConnectionsPanel';
import FinancialConfigurationTab from '../../pages/instances/settings/global-settings/FinancialConfigurationTab';

// ✅ MISSING IMPORTS (these were used but not defined/imported)
import ProjectTemplatesTab from '../../pages/instances/settings/global-settings/ProjectTemplatesTab';
import CompanyContactInfoTab from '../../pages/instances/settings/global-settings/CompanyContactInfoTab';
import CompanyTimezoneTab from '../../pages/instances/settings/global-settings/CompanyTimezoneTab';
import ShipMethodsTab from '../../pages/instances/settings/global-settings/ShipMethodsTab';
import LicensesTab from '../../pages/instances/settings/global-settings/LicensesTab';
import NoteManagementDialog from '../../pages/instances/settings/global-settings/NoteManagementDialog';
import CrmSettingsPanel from '../../pages/instances/settings/global-settings/CrmSettingsPanel';
import OperationsManagementSettingsPanel from '../../pages/instances/settings/global-settings/OperationsManagementSettingsPanel';
import ProductionSettingsPanel from '../../pages/instances/settings/global-settings/ProductionSettingsPanel';
import ProductionChargeRoutingPanel from '../../pages/instances/settings/global-settings/ProductionChargeRoutingPanel';
import PurchasingSettingsPanel from '../../pages/instances/settings/global-settings/PurchasingSettingsPanel';
import SalesBudgetsTab from '../../pages/instances/settings/global-settings/SalesBudgetsTab';
import SalesSettingsPanel from '../../pages/instances/settings/global-settings/SalesSettingsPanel';
import InternalShippingSettingsPanel from '../../pages/instances/settings/global-settings/InternalShippingSettingsPanel';
import ToolsPanel from '../../pages/instances/settings/global-settings/tools/ToolsPanel';
import ImportHistoryDialog from '../../pages/instances/settings/global-settings/tools/ImportHistoryDialog';
import ImportToolDialog from '../../pages/instances/settings/global-settings/tools/ImportToolDialog';
import OnlineStoreTransferDialog from '../../pages/instances/settings/global-settings/tools/OnlineStoreTransferDialog';
import ContactRepairBatchDialog from '../../pages/instances/settings/global-settings/tools/ContactRepairBatchDialog';
import ProjectCloneDialog from '../../pages/instances/settings/global-settings/tools/ProjectCloneDialog';
import { AuthContext } from '../../helpers/AuthContext';

const GLOBAL_SETTINGS_TABS = {
  companySettings: 0,
  billing: 1,
  promoShowcase: 2,
  tools: 3,
  licenses: 4,
  integrations: 5,
};

const GlobalSettingsTabs = () => {
  const { instanceUniqueId, tabType, settingType, subSettingType } = useParams();
  const history = useHistory();
  const { authState } = useContext(AuthContext);
  const normalizedRole = String(authState?.role || '').toLowerCase().replace(/_/g, '-');
  const isCrmManager = ['administrator', 'admin', 'manager', 'super-administrator'].includes(normalizedRole);
  const canAccessAllCompanySettings = ['administrator', 'admin', 'finance-rep', 'super-administrator'].includes(normalizedRole);
  const canRepairContacts = normalizedRole === 'administrator';
  const canManageSalesBudgets = ['administrator', 'admin', 'finance', 'finance-rep', 'manager', 'management', 'super-administrator'].includes(normalizedRole);
  const canManageSalesSettings = ['administrator', 'admin', 'finance', 'finance-rep', 'super-administrator'].includes(normalizedRole);
  const canManageProductionChargeRouting = ['administrator', 'admin', 'superadmin', 'super-administrator'].includes(normalizedRole);

  const [currentTab, setCurrentTab] = useState(0);

  const [openMatrix, setOpenMatrix] = useState(false);
  const [openEmailTemplates, setOpenEmailTemplates] = useState(false);
  const [openTaxCodes, setOpenTaxCodes] = useState(false);
  const [openPaymentTerms, setOpenPaymentTerms] = useState(false);
  const [openShippingAccounts, setOpenShippingAccounts] = useState(false);
  const [openThirdPartyShippingAccounts, setOpenThirdPartyShippingAccounts] = useState(false);
  const [openProjectNumbers, setOpenProjectNumbers] = useState(false);
  const [openCustomizationMethods, setOpenCustomizationMethods] = useState(false);
  const [openNextActionTypes, setOpenNextActionTypes] = useState(false);
  const [openClientStatuses, setOpenClientStatuses] = useState(false);
  const [openSupplierStatuses, setOpenSupplierStatuses] = useState(false);
  const [openSubStatuses, setOpenSubStatuses] = useState(false);
  const [openDefaults, setOpenDefaults] = useState(false);
  const [openCurrencySettings, setOpenCurrencySettings] = useState(false);
  const [openSalesBudgets, setOpenSalesBudgets] = useState(false);
  const [openCommissions, setOpenCommissions] = useState(false);
  const [openPromoStoreSettings, setOpenPromoStoreSettings] = useState(false);
  const [openFinancialConfiguration, setOpenFinancialConfiguration] = useState(false);

  const [openBillingPaymentMethods, setOpenBillingPaymentMethods] = useState(false);
  const [openBillingHistory, setOpenBillingHistory] = useState(false);
  const [openBillingRenewal, setOpenBillingRenewal] = useState(false);

  // ✅ MISSING STATE (these were referenced but never created)
  const [openProjectTemplates, setOpenProjectTemplates] = useState(false);
  const [openCompanyContactInfo, setOpenCompanyContactInfo] = useState(false);
  const [openCompanyTimezone, setOpenCompanyTimezone] = useState(false);
  const [openShipMethods, setOpenShipMethods] = useState(false);
  const [openNoteManagement, setOpenNoteManagement] = useState(false);
  const [openCrmSettings, setOpenCrmSettings] = useState(false);
  const [openOperationsManagement, setOpenOperationsManagement] = useState(false);
  const [openProductionSettings, setOpenProductionSettings] = useState(false);
  const [openSalesSettings, setOpenSalesSettings] = useState(false);
  const [openPurchasingSettings, setOpenPurchasingSettings] = useState(false);
  const [openProductionChargeRouting, setOpenProductionChargeRouting] = useState(false);
  const [openInternalShipping, setOpenInternalShipping] = useState(false);
  const [openImportTool, setOpenImportTool] = useState(false);
  const [openProjectClone, setOpenProjectClone] = useState(false);
  const [openImportHistory, setOpenImportHistory] = useState(false);
  const [openOnlineStoreTransfer, setOpenOnlineStoreTransfer] = useState(false);
  const [openContactRepairTool, setOpenContactRepairTool] = useState(false);
  const [instanceRecord, setInstanceRecord] = useState(null);

  useEffect(() => {
    if (!instanceUniqueId) {
      setInstanceRecord(null);
      return;
    }

    let cancelled = false;
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`)
      .then((res) => { if (!cancelled) setInstanceRecord(res.data || null); })
      .catch(() => { if (!cancelled) setInstanceRecord(null); });

    return () => { cancelled = true; };
  }, [instanceUniqueId]);

  const instanceId = instanceRecord?.id || instanceRecord?.Id || null;

  const companySettingsCards = [
    ...(isCrmManager ? [{
      key: 'crm',
      title: 'CRM',
      description: 'Manage CRM accountability, tags, and future notification and communication settings.',
      icon: <AccountTreeOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/crm`);
        setOpenCrmSettings(true);
      },
    }, {
      key: 'operations-management',
      title: 'Operations Management',
      description: 'Configure which management teams oversee operational teams, receive workflow notifications, and approve requests.',
      icon: <HubIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/operations-management`);
        setOpenOperationsManagement(true);
      },
    }, {
      key: 'production-settings',
      title: 'Production Settings',
      description: 'Configure Production notifications and Completed order archive retention.',
      icon: <SettingsOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/production-settings`);
        setOpenProductionSettings(true);
      },
    }, {
      key: 'purchasing-settings',
      title: 'Purchasing Settings',
      description: 'Configure instance-specific Purchasing behaviour and workflow options.',
      icon: <PlaylistAddCheckCircleOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/purchasing-settings`);
        setOpenPurchasingSettings(true);
      },
    }] : []),
    ...(canManageSalesSettings ? [{
      key: 'sales-settings',
      title: 'Sales Settings',
      description: 'Configure project visibility for Client Reps and Order Reps.',
      icon: <PeopleOutlineOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/sales-settings`);
        setOpenSalesSettings(true);
      },
    }] : []),
    {
      key: 'production-charge-routing',
      title: 'Production Charge Routing',
      description: 'Manage effective charge routing for this company. Global defaults are inherited unless you create an override.',
      icon: <AltRouteIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/production-charge-routing`);
        setOpenProductionChargeRouting(true);
      },
    },
    {
      key: 'decorator-matrix',
      title: 'Decorator Matrix',
      description: 'Manage decorator routing and configuration.',
      icon: <DashboardCustomizeIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/decorator-matrix`
        );
        setOpenMatrix(true);
      },
    },
    {
      key: 'email-templates',
      title: 'Email Templates',
      description: 'Create, edit, and preview instance email templates.',
      icon: <MarkEmailReadIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/email-templates`
        );
        setOpenEmailTemplates(true);
      },
    },
    {
      key: 'promostore-settings',
      title: 'PromoStores',
      description: 'Configure PromoStore developer requests and defaults.',
      icon: <StorefrontOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/promostore-settings`
        );
        setOpenPromoStoreSettings(true);
      },
    },
    {
      key: 'note-management',
      title: 'Note Management',
      description: 'View note buckets, scopes, and where each note type appears.',
      icon: <StickyNote2OutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/note-management`
        );
        setOpenNoteManagement(true);
      },
    },
    {
      key: 'project-templates',
      title: 'Project Templates',
      description: 'Manage project document headers and footers.',
      icon: <DescriptionOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/project-templates`
        );
        setOpenProjectTemplates(true);
      },
    },
    {
      key: 'company-timezone',
      title: 'Company Timezone',
      description: 'Set the timezone used for instance-aware timestamps across Elite Core.',
      icon: <BusinessIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/company-timezone`
        );
        setOpenCompanyTimezone(true);
      },
    },
    {
      key: 'company-contact-info',
      title: 'Company Contact Info',
      description: 'Manage company addresses for document footers.',
      icon: <ContactMailOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/company-contact-info`
        );
        setOpenCompanyContactInfo(true);
      },
    },
    {
      key: 'financial-configuration',
      title: 'Financial Configuration',
      description: 'Control invoice, billing, and finance behavior for this instance.',
      icon: <AccountBalanceOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/financial-configuration`
        );
        setOpenFinancialConfiguration(true);
      },
    },
    {
      key: 'defaults',
      title: 'Defaults',
      description: 'Configure default settings for this instance.',
      icon: <SettingsOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/defaults`
        );
        setOpenDefaults(true);
      },
    },
    {
      key: 'currency',
      title: 'Currency',
      description: 'Configure enabled currencies and manual exchange rates.',
      icon: <CurrencyExchangeOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/currency`
        );
        setOpenCurrencySettings(true);
      },
    },
    {
      key: 'sales-budgets',
      title: 'Sales Budgets',
      description: 'Set company-level monthly sales targets used by reports and budget comparisons.',
      icon: <TrendingUpOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/sales-budgets`
        );
        setOpenSalesBudgets(true);
      },
    },
    {
      key: 'commissions',
      title: 'Commissions',
      description: 'Manage commission rates and assignments.',
      icon: <PercentOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/commissions`
        );
        setOpenCommissions(true);
      },
    },
    {
      key: 'tax-codes',
      title: 'Tax Codes',
      description: 'Manage tax codes for this instance.',
      icon: <LocalAtmOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/tax-codes`
        );
        setOpenTaxCodes(true);
      },
    },
    {
      key: 'payment-terms',
      title: 'Payment Terms',
      description: 'Manage payment terms for this instance.',
      icon: <PaidOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/payment-terms`
        );
        setOpenPaymentTerms(true);
      },
    },
    {
      key: 'project-numbers',
      title: 'Project Numbers',
      description: 'Set starting numbers for project references.',
      icon: <NumbersOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/project-numbers`
        );
        setOpenProjectNumbers(true);
      },
    },
    {
      key: 'client-statuses',
      title: 'Client Statuses',
      description: 'Manage client statuses for this instance.',
      icon: <PeopleOutlineOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/client-statuses`
        );
        setOpenClientStatuses(true);
      },
    },
    {
      key: 'sub-statuses',
      title: 'Sub Statuses',
      description: 'Manage foundational-status sub statuses for this instance.',
      icon: <PeopleOutlineOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/sub-statuses`
        );
        setOpenSubStatuses(true);
      },
    },
    {
      key: 'supplier-statuses',
      title: 'Supplier Statuses',
      description: 'Manage supplier statuses for this instance.',
      icon: <PeopleOutlineOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/supplier-statuses`
        );
        setOpenSupplierStatuses(true);
      },
    },
    {
      key: 'internal-shipping',
      title: 'Internal Shipping',
      description: 'Manage internal shipping contacts and shipping update notifications.',
      icon: <LocalShippingOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/internal-shipping`
        );
        setOpenInternalShipping(true);
      },
    },
    {
      key: 'ship-methods',
      title: 'Ship Methods',
      description: 'Manage available ship methods for orders.',
      icon: <LocalShippingOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/ship-methods`
        );
        setOpenShipMethods(true);
      },
    },
    {
      key: 'shipping-accounts',
      title: 'Shipping Accounts',
      description: 'Manage your shipping accounts.',
      icon: <LocalShippingTwoToneIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/shipping-accounts`
        );
        setOpenShippingAccounts(true);
      },
    },
    {
      key: 'third-party-shipping-accounts',
      title: 'Third Party Shipping Accounts',
      description: 'Manage client-provided shipping accounts.',
      icon: <LocalShippingOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/third-party-shipping-accounts`
        );
        setOpenThirdPartyShippingAccounts(true);
      },
    },
    {
      key: 'imprint-methods',
      title: 'Imprint Methods',
      description: 'Manage imprint types for this instance.',
      icon: <PrintOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/imprint-methods`
        );
        setOpenCustomizationMethods(true);
      },
    },
    {
      key: 'po-next-action-types',
      title: 'PO - Next Action Types',
      description: 'Manage PO next action types.',
      icon: <PlaylistAddCheckCircleOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/company-settings/po-next-action-types`
        );
        setOpenNextActionTypes(true);
      },
    },
  ];
  const visibleCompanySettingsCards = canAccessAllCompanySettings
    ? companySettingsCards
    : companySettingsCards.filter((card) =>
      card.key === 'crm' ||
      card.key === 'operations-management' ||
      card.key === 'production-settings' ||
      card.key === 'sales-settings' ||
      card.key === 'purchasing-settings' ||
      (card.key === 'sales-budgets' && canManageSalesBudgets)
    );

  // ✅ MISSING: billingSettingsCards was referenced but not defined
  const billingSettingsCards = [
    {
      key: 'payment-methods',
      title: 'Payment Methods',
      description: 'Manage payment methods for billing.',
      icon: <PaidOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/billing/payment-methods`
        );
        setOpenBillingPaymentMethods(true);
      },
    },
    {
      key: 'billing-history',
      title: 'Billing History',
      description: 'View invoices, payments, and billing records.',
      icon: <ReceiptLongIcon color="primary" />,
      onClick: () => {
        history.push(
          `/instance/${instanceUniqueId}/settings/global-settings/billing/billing-history`
        );
        setOpenBillingHistory(true);
      },
    },
    {
      key: 'renewal',
      title: 'Renewal',
      description: 'Manage renewal and subscription details.',
      icon: <PercentOutlinedIcon color="primary" />,
      onClick: () => {
        history.push(`/instance/${instanceUniqueId}/settings/global-settings/billing/renewal`);
        setOpenBillingRenewal(true);
      },
    },
  ];

  const handleChange = (_e, newValue) => {
    setCurrentTab(newValue);
    const newTabType =
      newValue === GLOBAL_SETTINGS_TABS.companySettings ? 'company-settings' :
      newValue === GLOBAL_SETTINGS_TABS.billing ? 'billing' :
      newValue === GLOBAL_SETTINGS_TABS.promoShowcase ? 'promoshowcase' :
      newValue === GLOBAL_SETTINGS_TABS.tools ? 'tools' :
      newValue === GLOBAL_SETTINGS_TABS.licenses ? 'licenses' :
      'integrations';
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/${newTabType}`);
  };

  const canCloneProjects = ['administrator', 'admin', 'superadmin', 'super-administrator'].includes(normalizedRole);
  const openProjectCloneRoute = () => {
    if (!canCloneProjects) return;
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools/project-clone`);
    setOpenProjectClone(true);
  };
  const closeProjectCloneRoute = () => {
    setOpenProjectClone(false);
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools`);
  };

  const openImportToolRoute = () => {
    if (!canAccessAllCompanySettings) return;
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools/import`);
    setOpenImportTool(true);
  };

  const closeImportToolRoute = () => {
    setOpenImportTool(false);
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools`);
  };

  const openContactRepairToolRoute = () => {
    if (!canRepairContacts) return;
    setOpenImportTool(false);
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools/contact-repair`);
    setOpenContactRepairTool(true);
  };

  const closeContactRepairToolRoute = () => {
    setOpenContactRepairTool(false);
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools/import`);
    setOpenImportTool(true);
  };

  const openOnlineStoreTransferRoute = () => {
    if (!canAccessAllCompanySettings) return;
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools/transfer-online-store`);
    setOpenOnlineStoreTransfer(true);
  };

  const closeOnlineStoreTransferRoute = () => {
    setOpenOnlineStoreTransfer(false);
    history.push(`/instance/${instanceUniqueId}/settings/global-settings/tools`);
  };

  useEffect(() => {
    if (tabType === 'company-settings') setCurrentTab(GLOBAL_SETTINGS_TABS.companySettings);
    else if (tabType === 'email-templates') setCurrentTab(GLOBAL_SETTINGS_TABS.companySettings);
    else if (tabType === 'billing') setCurrentTab(GLOBAL_SETTINGS_TABS.billing);
    else if (tabType === 'promoshowcase' || tabType === 'website') setCurrentTab(GLOBAL_SETTINGS_TABS.promoShowcase);
    else if (tabType === 'tools') setCurrentTab(GLOBAL_SETTINGS_TABS.tools);
    else if (tabType === 'licenses') setCurrentTab(GLOBAL_SETTINGS_TABS.licenses);
    else if (tabType === 'charge-map') setCurrentTab(GLOBAL_SETTINGS_TABS.companySettings);
    else if (tabType === 'integrations') setCurrentTab(GLOBAL_SETTINGS_TABS.integrations);

    setOpenMatrix(settingType === 'decorator-matrix');
    setOpenContactRepairTool(
      tabType === 'tools' && settingType === 'contact-repair' && canRepairContacts
    );
    setOpenOnlineStoreTransfer(
      tabType === 'tools' &&
      settingType === 'transfer-online-store' &&
      canAccessAllCompanySettings
    );

    setOpenEmailTemplates(settingType === 'email-templates' || tabType === 'email-templates');
    setOpenTaxCodes(settingType === 'tax-codes');
    setOpenPaymentTerms(settingType === 'payment-terms');
    setOpenShippingAccounts(settingType === 'shipping-accounts');
    setOpenThirdPartyShippingAccounts(settingType === 'third-party-shipping-accounts');
    setOpenProjectNumbers(settingType === 'project-numbers');
    setOpenCustomizationMethods(settingType === 'imprint-methods');
    setOpenNextActionTypes(settingType === 'po-next-action-types');
    setOpenClientStatuses(settingType === 'client-statuses');
    setOpenSupplierStatuses(settingType === 'supplier-statuses');
    setOpenSubStatuses(settingType === 'sub-statuses');
    setOpenDefaults(settingType === 'defaults');
    setOpenCurrencySettings(settingType === 'currency');
    setOpenSalesBudgets(settingType === 'sales-budgets');
    setOpenCommissions(settingType === 'commissions');
    setOpenPromoStoreSettings(settingType === 'promostore-settings');
    setOpenFinancialConfiguration(settingType === 'financial-configuration');

    // ✅ these were previously calling undefined setters
    setOpenProjectTemplates(settingType === 'project-templates');
    setOpenCompanyContactInfo(settingType === 'company-contact-info');
    setOpenCompanyTimezone(settingType === 'company-timezone');
    setOpenShipMethods(settingType === 'ship-methods');
    setOpenNoteManagement(settingType === 'note-management');
    setOpenCrmSettings(settingType === 'crm' && isCrmManager);
    setOpenOperationsManagement(settingType === 'operations-management' && isCrmManager);
    setOpenProductionSettings(settingType === 'production-settings' && isCrmManager);
    setOpenSalesSettings(settingType === 'sales-settings' && canManageSalesSettings);
    setOpenPurchasingSettings(settingType === 'purchasing-settings' && isCrmManager);
    setOpenProductionChargeRouting(
      settingType === 'production-charge-routing' || tabType === 'charge-map'
    );
    setOpenInternalShipping(settingType === 'internal-shipping');

    // Billing modals (based on routes)
    setOpenBillingPaymentMethods(settingType === 'payment-methods');
    setOpenBillingHistory(settingType === 'billing-history');
    setOpenBillingRenewal(settingType === 'renewal');
    setOpenImportTool(tabType === 'tools' && settingType === 'import' && canAccessAllCompanySettings);
    setOpenProjectClone(tabType === 'tools' && settingType === 'project-clone' && canCloneProjects);

    if (tabType === 'charge-map') {
      history.replace(`/instance/${instanceUniqueId}/settings/global-settings/company-settings/production-charge-routing`);
    }
  }, [canAccessAllCompanySettings, canCloneProjects, canManageSalesSettings, canRepairContacts,
    history, instanceUniqueId, isCrmManager, settingType, tabType]);

  return (
    <Box className={styles.presentationTabContainer}>
      <Tabs
        className={styles.tabHeaderContainer}
        value={currentTab}
        onChange={handleChange}
        aria-label="Global settings tabs"
        sx={{
          marginBottom: 0,
          paddingBottom: 0,
          background: "#dce7ff",
          padding: 0,
          '& .MuiTabs-indicator': { backgroundColor: '#dce7ff' },
        }}
      >
        <Tab
          icon={<BusinessIcon fontSize="small" />}
          iconPosition="start"
          sx={{
            color: currentTab === 0 ? '#c3171d !important' : '#000001 !important',
            backgroundColor: currentTab === 0 ? 'white !important' : 'transparent !important',
            '& .MuiTab-iconWrapper': { mr: 1 },
          }}
          label="Company Settings"
          className={styles.tabLabel}
        />
        <Tab
          icon={<ReceiptLongIcon fontSize="small" />}
          iconPosition="start"
          sx={{
            color: currentTab === 1 ? '#c3171d !important' : '#000001 !important',
            backgroundColor: currentTab === 1 ? 'white !important' : 'transparent !important',
            '& .MuiTab-iconWrapper': { mr: 1 },
          }}
          label="Billing"
          className={styles.tabLabel}
        />
        <Tab
          icon={<LanguageIcon fontSize="small" />}
          iconPosition="start"
          sx={{
            color: currentTab === 2 ? '#c3171d !important' : '#000001 !important',
            backgroundColor: currentTab === 2 ? 'white !important' : 'transparent !important',
            '& .MuiTab-iconWrapper': { mr: 1 },
          }}
          label="PromoShowcase"
          className={styles.tabLabel}
        />
        <Tab
          icon={<BuildOutlinedIcon fontSize="small" />}
          iconPosition="start"
          sx={{
            color: currentTab === 3 ? '#c3171d !important' : '#000001 !important',
            backgroundColor: currentTab === 3 ? 'white !important' : 'transparent !important',
            '& .MuiTab-iconWrapper': { mr: 1 },
          }}
          label="Tools"
          className={styles.tabLabel}
        />
        <Tab
          icon={<WorkspacePremiumOutlinedIcon fontSize="small" />}
          iconPosition="start"
          sx={{
            color: currentTab === 4 ? '#c3171d !important' : '#000001 !important',
            backgroundColor: currentTab === 4 ? 'white !important' : 'transparent !important',
            '& .MuiTab-iconWrapper': { mr: 1 },
          }}
          label="Licenses"
          className={styles.tabLabel}
        />
        <Tab
          icon={<HubIcon fontSize="small" />}
          iconPosition="start"
          sx={{
            color: currentTab === 5 ? '#c3171d !important' : '#000001 !important',
            backgroundColor: currentTab === 5 ? 'white !important' : 'transparent !important',
            '& .MuiTab-iconWrapper': { mr: 1 },
          }}
          label="Integrations"
          className={styles.tabLabel}
        />
      </Tabs>

      <Box className={`${styles.tabContentWrapper} global-settings-tab-content`}>
        {/* Company settings */}
        <TabPanel value={currentTab} index={GLOBAL_SETTINGS_TABS.companySettings}>
          <Box sx={{ padding: 0, marginLeft: '20px', height: '100%' }} className={styles.tabPanelContent}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: 2,
                pr: 2,
              }}
            >
              {visibleCompanySettingsCards.map((card) => (
                <Card
                  key={card.key}
                  elevation={3}
                  onClick={card.disabled ? undefined : card.onClick}
                  sx={{
                    cursor: card.disabled ? 'default' : 'pointer',
                    padding: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    border: '1px solid #e0e0e0',
                    opacity: card.disabled ? 0.6 : 1,
                    '&:hover': card.disabled ? undefined : { boxShadow: 6, backgroundColor: '#f9f9f9' },
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {card.icon}
                    <CardContent sx={{ padding: '0 !important' }}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {card.title}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.75 }}>
                        {card.description}
                      </Typography>
                    </CardContent>
                  </Box>
                </Card>
              ))}
            </Box>

            <DecoratorMatrix
              open={openMatrix}
              onClose={() => setOpenMatrix(false)}
              instanceId={instanceId}
            />

            <Dialog open={openCrmSettings} onClose={() => setOpenCrmSettings(false)} maxWidth="lg" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">CRM Settings</Typography>
                <IconButton onClick={() => setOpenCrmSettings(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <CrmSettingsPanel instanceUniqueId={instanceUniqueId} canManage={isCrmManager} />
              </DialogContent>
            </Dialog>

            <Dialog open={openOperationsManagement} onClose={() => setOpenOperationsManagement(false)} maxWidth="lg" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Operations Management</Typography>
                <IconButton onClick={() => setOpenOperationsManagement(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <OperationsManagementSettingsPanel instanceUniqueId={instanceUniqueId} canManage={isCrmManager} />
              </DialogContent>
            </Dialog>

            <Dialog open={openProductionSettings} onClose={() => setOpenProductionSettings(false)} maxWidth="lg" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Production Settings</Typography>
                <IconButton onClick={() => setOpenProductionSettings(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ProductionSettingsPanel instanceUniqueId={instanceUniqueId} canManage={isCrmManager} />
              </DialogContent>
            </Dialog>

            <Dialog open={openSalesSettings} onClose={() => setOpenSalesSettings(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Sales Settings</Typography>
                <IconButton onClick={() => setOpenSalesSettings(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <SalesSettingsPanel instanceUniqueId={instanceUniqueId} canManage={canManageSalesSettings} />
              </DialogContent>
            </Dialog>

            <Dialog open={openProductionChargeRouting} onClose={() => setOpenProductionChargeRouting(false)} maxWidth="xl" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Production Charge Routing</Typography>
                <IconButton onClick={() => setOpenProductionChargeRouting(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ProductionChargeRoutingPanel
                  instanceUniqueId={instanceUniqueId}
                  instanceId={instanceId}
                  canManage={canManageProductionChargeRouting}
                />
              </DialogContent>
            </Dialog>

            <Dialog open={openPurchasingSettings} onClose={() => setOpenPurchasingSettings(false)} maxWidth="lg" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Purchasing Settings</Typography>
                <IconButton onClick={() => setOpenPurchasingSettings(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <PurchasingSettingsPanel instanceUniqueId={instanceUniqueId} canManage={isCrmManager} />
              </DialogContent>
            </Dialog>

            <Dialog open={openInternalShipping} onClose={() => setOpenInternalShipping(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Internal Shipping</Typography>
                <IconButton onClick={() => setOpenInternalShipping(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <InternalShippingSettingsPanel instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            <Dialog
              open={openPromoStoreSettings}
              onClose={() => setOpenPromoStoreSettings(false)}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">PromoStores</Typography>
                <IconButton onClick={() => setOpenPromoStoreSettings(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <PromoStoreSettingsPanel instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Email Templates */}
            <Dialog
              open={openEmailTemplates}
              onClose={() => setOpenEmailTemplates(false)}
              maxWidth="lg"
              fullWidth
              PaperProps={{ sx: { minWidth: '90%' } }}
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Email Templates</Typography>
                <IconButton onClick={() => setOpenEmailTemplates(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <EmailTemplatesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Tax Codes */}
            <Dialog
              open={openTaxCodes}
              onClose={() => setOpenTaxCodes(false)}
              maxWidth="lg"
              fullWidth
              PaperProps={{ sx: { minWidth: '90%' } }}
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Tax Codes</Typography>
                <IconButton onClick={() => setOpenTaxCodes(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <TaxCodesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Payment Terms */}
            <Dialog open={openPaymentTerms} onClose={() => setOpenPaymentTerms(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Payment Terms</Typography>
                <IconButton onClick={() => setOpenPaymentTerms(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <PaymentTermsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Shipping Accounts */}
            <Dialog open={openShippingAccounts} onClose={() => setOpenShippingAccounts(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Shipping Accounts</Typography>
                <IconButton onClick={() => setOpenShippingAccounts(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ShippingAccountsTab />
              </DialogContent>
            </Dialog>

            {/* Third Party Shipping Accounts */}
            <Dialog
              open={openThirdPartyShippingAccounts}
              onClose={() => setOpenThirdPartyShippingAccounts(false)}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Third Party Shipping Accounts</Typography>
                <IconButton onClick={() => setOpenThirdPartyShippingAccounts(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ThirdPartyShippingAccountsTab />
              </DialogContent>
            </Dialog>

            {/* Project Numbers */}
            <Dialog open={openProjectNumbers} onClose={() => setOpenProjectNumbers(false)} maxWidth="sm" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Project Numbers</Typography>
                <IconButton onClick={() => setOpenProjectNumbers(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ProjectNumbersTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Imprint Types */}
            <Dialog open={openCustomizationMethods} onClose={() => setOpenCustomizationMethods(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Imprint Types</Typography>
                <IconButton onClick={() => setOpenCustomizationMethods(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <CustomizationMethodsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* PO Next Action Types */}
            <Dialog open={openNextActionTypes} onClose={() => setOpenNextActionTypes(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">PO - Next Action Types</Typography>
                <IconButton onClick={() => setOpenNextActionTypes(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <NextActionTypesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Client Statuses */}
            <Dialog open={openClientStatuses} onClose={() => setOpenClientStatuses(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Client Statuses</Typography>
                <IconButton onClick={() => setOpenClientStatuses(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ClientStatusesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Supplier Statuses */}
            <Dialog open={openSupplierStatuses} onClose={() => setOpenSupplierStatuses(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Supplier Statuses</Typography>
                <IconButton onClick={() => setOpenSupplierStatuses(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <SupplierStatusesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            <Dialog open={openSubStatuses} onClose={() => setOpenSubStatuses(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h6">Sub Statuses</Typography>
                <IconButton onClick={() => setOpenSubStatuses(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <SubStatusesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Financial Configuration */}
            <Dialog open={openFinancialConfiguration} onClose={() => setOpenFinancialConfiguration(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Financial Configuration</Typography>
                <IconButton onClick={() => setOpenFinancialConfiguration(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <FinancialConfigurationTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Defaults */}
            <Dialog
              open={openDefaults}
              onClose={() => setOpenDefaults(false)}
              maxWidth={false}
              fullWidth
              PaperProps={{
                sx: {
                  width: { xs: '95vw', md: '50vw' },
                  maxWidth: { xs: '95vw', md: '50vw' },
                },
              }}
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Defaults</Typography>
                <IconButton onClick={() => setOpenDefaults(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <DefaultsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Currency */}
            <Dialog open={openCurrencySettings} onClose={() => setOpenCurrencySettings(false)} maxWidth="sm" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Currency</Typography>
                <IconButton onClick={() => setOpenCurrencySettings(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <CurrencySettingsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            <Dialog open={openSalesBudgets} onClose={() => setOpenSalesBudgets(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Sales Budgets</Typography>
                <IconButton onClick={() => setOpenSalesBudgets(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <SalesBudgetsTab instanceUniqueId={instanceUniqueId} canManage={canManageSalesBudgets} />
              </DialogContent>
            </Dialog>

            {/* Commissions */}
            <Dialog open={openCommissions} onClose={() => setOpenCommissions(false)} maxWidth="lg" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Commissions</Typography>
                <IconButton onClick={() => setOpenCommissions(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <CommissionsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Project Templates */}
            <Dialog open={openProjectTemplates} onClose={() => setOpenProjectTemplates(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Project Templates</Typography>
                <IconButton onClick={() => setOpenProjectTemplates(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ProjectTemplatesTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Company Contact Info */}
            <Dialog open={openCompanyTimezone} onClose={() => setOpenCompanyTimezone(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Company Timezone</Typography>
                <IconButton onClick={() => setOpenCompanyTimezone(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <CompanyTimezoneTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Company Contact Info */}
            <Dialog open={openCompanyContactInfo} onClose={() => setOpenCompanyContactInfo(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Company Contact Info</Typography>
                <IconButton onClick={() => setOpenCompanyContactInfo(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <CompanyContactInfoTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            {/* Ship Methods */}
            <Dialog open={openShipMethods} onClose={() => setOpenShipMethods(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Ship Methods</Typography>
                <IconButton onClick={() => setOpenShipMethods(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <ShipMethodsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            <Dialog
              open={openNoteManagement}
              onClose={() => setOpenNoteManagement(false)}
              maxWidth="xl"
              fullWidth
              PaperProps={{ sx: { minWidth: '92%' } }}
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
                <Box>
                  <Typography variant="h6">Note Management</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    Shows how note actions are categorized and where they appear. Production includes purchasing,
                    shipping, proofs, supplier communication, PO tasks, tracking, and receiving.
                  </Typography>
                </Box>
                <IconButton onClick={() => setOpenNoteManagement(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <NoteManagementDialog />
              </DialogContent>
            </Dialog>
          </Box>
        </TabPanel>

        {/* Billing */}
        <TabPanel value={currentTab} index={GLOBAL_SETTINGS_TABS.billing}>
          <Box sx={{ padding: 0, marginLeft: '20px', height: '100%' }} className={styles.tabPanelContent}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: 2,
                pr: 2,
              }}
            >
              {billingSettingsCards.map((card) => (
                <Card
                  key={card.key}
                  elevation={3}
                  onClick={card.onClick}
                  sx={{
                    cursor: 'pointer',
                    padding: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    border: '1px solid #e0e0e0',
                    '&:hover': { boxShadow: 6, backgroundColor: '#f9f9f9' },
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {card.icon}
                    <CardContent sx={{ padding: '0 !important' }}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {card.title}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.75 }}>
                        {card.description}
                      </Typography>
                    </CardContent>
                  </Box>
                </Card>
              ))}
            </Box>

            <Dialog
              open={openBillingPaymentMethods}
              onClose={() => setOpenBillingPaymentMethods(false)}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Payment Methods</Typography>
                <IconButton onClick={() => setOpenBillingPaymentMethods(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <BillingPaymentMethodsTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            <Dialog open={openBillingHistory} onClose={() => setOpenBillingHistory(false)} maxWidth="lg" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Billing History</Typography>
                <IconButton onClick={() => setOpenBillingHistory(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <BillingHistoryTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>

            <Dialog open={openBillingRenewal} onClose={() => setOpenBillingRenewal(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Renewal</Typography>
                <IconButton onClick={() => setOpenBillingRenewal(false)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ backgroundColor: '#f8fafb' }}>
                <BillingRenewalTab instanceUniqueId={instanceUniqueId} />
              </DialogContent>
            </Dialog>
          </Box>
        </TabPanel>

        {/* Website */}
        <TabPanel value={currentTab} index={GLOBAL_SETTINGS_TABS.promoShowcase}>
          <PromoShowcaseSettingsPanel instanceUniqueId={instanceUniqueId} />
        </TabPanel>

        {/* Tools */}
        <TabPanel value={currentTab} index={GLOBAL_SETTINGS_TABS.tools}>
          <ToolsPanel
            canManageTools={canAccessAllCompanySettings}
            onOpenImport={openImportToolRoute}
            onOpenImportHistory={() => setOpenImportHistory(true)}
            canViewImportHistory={['administrator', 'admin', 'superadmin', 'super-administrator'].includes(normalizedRole)}
            onOpenOnlineStoreTransfer={openOnlineStoreTransferRoute}
            canCloneProjects={canCloneProjects}
            onOpenProjectClone={openProjectCloneRoute}
          />
          {canCloneProjects && <ProjectCloneDialog open={openProjectClone} onClose={closeProjectCloneRoute} instanceUniqueId={instanceUniqueId} />}
          <ImportHistoryDialog open={openImportHistory} onClose={() => setOpenImportHistory(false)} instanceUniqueId={instanceUniqueId} />
          <ImportToolDialog
            open={openImportTool}
            onClose={closeImportToolRoute}
            instanceUniqueId={instanceUniqueId}
            initialImportType={subSettingType || null}
            canRepairContacts={canRepairContacts}
            onOpenContactRepair={openContactRepairToolRoute}
          />
          <OnlineStoreTransferDialog
            open={openOnlineStoreTransfer}
            onClose={closeOnlineStoreTransferRoute}
            instanceUniqueId={instanceUniqueId}
          />
          {canRepairContacts && (
            <ContactRepairBatchDialog
              open={openContactRepairTool}
              onClose={closeContactRepairToolRoute}
              instanceUniqueId={instanceUniqueId}
            />
          )}
        </TabPanel>

        {/* Licenses */}
        <TabPanel value={currentTab} index={GLOBAL_SETTINGS_TABS.licenses}>
          <LicensesTab instanceUniqueId={instanceUniqueId} />
        </TabPanel>

        {/* Integrations */}
        <TabPanel value={currentTab} index={GLOBAL_SETTINGS_TABS.integrations}>
          <Box sx={{ p: 2 }} className={styles.tabPanelContent}>
            <Box sx={{ display: 'grid', gap: 2 }}>
              <MarketingConnectionsPanel instanceUniqueId={instanceUniqueId} />
              {['administrator', 'admin', 'superadmin', 'super-administrator'].includes(normalizedRole) && <OneSourceSettings instanceUniqueId={instanceUniqueId} />}
              <PromoWorldApiSettings instanceId={instanceId} />
              <StripeSettings instanceUniqueId={instanceUniqueId} />
              <QuickBooksSettings instanceUniqueId={instanceUniqueId} />
              <ShipStationSettings instanceUniqueId={instanceUniqueId} />
              <GooglePlacesSettings instanceUniqueId={instanceUniqueId} />
              <BinatedSettings instanceUniqueId={instanceUniqueId} />
            </Box>
          </Box>
        </TabPanel>
      </Box>
    </Box>
  );
};

export default GlobalSettingsTabs;
